



































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import {
  Alert, NoticeClass, Dialog, AuthStore,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import {
  EocEmailConfig, EocEmailConfigResource, EocEmailEvent,
  EocEmailEventResource, EocEmailMetrics, EocEmailMetricsResource,
  TestEmail, SendEocEmailResource,
} from '@/api/eocemailsettings';
import { Cycle, CycleResource } from '@/api/cycles';
import { Product, ProductResource } from '@/api/product';
import { EmailValidationTool, ValidationTool } from '@/util';

@Component({
  computed: mapState(['fiId', 'configVersion', 'auth']),
  components: {
    KCardHeader,
  },
})
export default class EocEmailSettings extends Vue {
  @Inject('EocEmailConfigResource')
  eocEmailConfigResource!: EocEmailConfigResource;

  @Inject('EocEmailEventResource')
  eocEmailEventResource!: EocEmailEventResource;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  @Inject('EocEmailMetricsResource')
  eocEmailMetricsResource!: EocEmailMetricsResource;

  @Inject('SendEocEmailResource')
  sendEocEmailResource!: SendEocEmailResource;

  @Inject('ProductResource')
  productResource!: ProductResource;

  fiId!: string;

  auth!: AuthStore;

  eocEmailConfig: EocEmailConfig | null = null;

  workingEocEmailConfig: EocEmailConfig = EocEmailConfigResource.createEmptyEocEmailConfig();

  eocEmailEvents: EocEmailEvent[] = [];

  sendHistoryForSelectedCycle: EocEmailEvent[] = [];

  eocEmailMetricsForSelectedCycle: EocEmailMetrics | null = null;

  activeProducts: Product[] = [];

  cycleDropDownItems: CycleDropDownItem[] = [];

  selectedCycleDropDownItem: CycleDropDownItem|null = null;

  testEmailAddress: string | null = null;

  eocEmailEnableFlagsOnLoad = new Map<number, boolean>();

  // progress status
  loading: boolean = false;

  saving: boolean = false;

  isEmailCountLoading: boolean = false;

  isValid: boolean = true;

  // button enable/disable
  isTestEmailValid: boolean = false;

  enableSendEmail: boolean = false;

  hasUnsavedConfigData: boolean = false;

  hasUnsavedEnableEocEmailFlag: boolean = false;

  hasInvalidBatchSize: boolean = false;

  invalidUrlError: boolean = false;

  batchSizeRule:Array<any> = [(v:string|number) => ValidationTool.requiredAndBetweenRuleFunction(v, 1, 100, 'Batch Size')];

  fromEmailAddressRule:Array<any> = [(v:string) => EmailValidationTool.fromEmailValidation(this.workingEocEmailConfig.fromEmailAddress,
    this.workingEocEmailConfig.emailProvider)];

  sfmcFromEmailFiSubDomain:Array<any> = [(v:string) => EmailValidationTool.fromSfmcEmailValidation(this.workingEocEmailConfig.fromSfmcEmailUsername,
    this.workingEocEmailConfig.emailProvider)];

  insuranceLogos:{ key: string|null, text: string }[]
    = [{ key: null, text: 'Select ...' },
      { key: 'FDIC', text: 'FDIC' },
      { key: 'FDIC_DIF', text: 'FDIC-DIF' },
      { key: 'NCUA', text: 'NCUA' },
      { key: 'NCUA_MSIC', text: 'NCUA-MSIC' },
      { key: 'ASI', text: 'ASI' },
      { key: 'ASI_ESI', text: 'ASI-ESI' },
    ];

  housingLogos:{ key: string|null, text: string }[]
    = [{ key: null, text: 'Select ...' },
      { key: 'EHL', text: 'Equal Housing Lender' },
      { key: 'EHO', text: 'Equal Housing Opportunity' },
      { key: 'NONE', text: 'None' },
    ];

  emailProviders :{ key: string|null, text: string }[]
    = [{ key: null, text: 'Select ...' },
      { key: 'SPARKPOST', text: 'SparkPost' },
      { key: 'SALESFORCE_MARKETING_CLOUD', text: 'Salesforce Marketing Cloud' },
    ];

  sendHistoryHeaders:DataTableHeader[] = [
    { text: 'Timestamp', value: 'timestamp', sortable: false },
    { text: 'Product Mapping ID', value: 'externalProductMappingId', sortable: false },
    { text: 'FI Product Name', value: 'productMappingFiProductName', sortable: false },
  ];

  footerProps = {
    'items-per-page-options': [-1, 25, 50, 100],
  }

  urlPattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ipv4 address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  emailPattern = /.+@.+\..+/;

  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'End of Cycle Email',
      disabled: true,
    },
  ];


  @Watch('fiId')
  mounted() {
    this.loadAllData();
  }

  loadAllData() {
    this.eocEmailConfig = null;
    this.loading = true;
    this.eocEmailConfigResource
      .get(this.fiId)
      .then((res: EocEmailConfig) => {
        this.eocEmailConfig = res;
        this.initializeWorkingEocEmailConfig();
        this.getCycles();
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  initializeWorkingEocEmailConfig() {
    this.hasUnsavedConfigData = false;
    if (this.eocEmailConfig) {
      Object.assign(this.workingEocEmailConfig, this.eocEmailConfig);
    }
  }

  getCycles() {
    this.cycleDropDownItems = [];
    this.cycleResource
      .getAllCycles(this.fiId)
      .then((res: Cycle[]) => {
        const today = new Date().getTime();
        const filteredCycles = res.filter((cycle: Cycle) => Date.parse(cycle.dropDate) <= today);
        filteredCycles.forEach((cycle: Cycle) => {
          this.cycleDropDownItems.push({
            dropDate: this.getFormattedDropDate(cycle.dropDate),
            id: cycle.id,
          });
        });
        this.selectedCycleDropDownItem = this.cycleDropDownItems[0];

        this.getActiveProducts();
        this.getEocEmailEvents();
        this.getEocEmailMetrics();
      });
  }

  getFormattedDropDate = (dropDate : string) => {
    const [year, month, day] = dropDate.split('-');
    return `Drop Date: ${month}/${day}/${year}`;
  }

  getActiveProducts() {
    this.activeProducts = [];
    this.productResource
      .getCurrentForConfigVersion(this.fiId)
      .then((res: Product[]) => {
        this.activeProducts = res.filter((product: Product) => product.active === true
        && product.productMapping !== null
        && product.productMapping.productType !== 'KASASA_SAVER');
        this.getEocEmailEnableFlagsOnLoad();
      });
  }

  getEocEmailEnableFlagsOnLoad() {
    this.activeProducts.forEach((activeProduct) => {
      this.eocEmailEnableFlagsOnLoad.set(activeProduct.id!, activeProduct.eocEmailEnabled);
    });
    this.hasUnsavedEnableEocEmailFlag = false;
  }

  getEocEmailEvents() {
    this.eocEmailEvents = [];
    this.eocEmailEventResource
      .get(this.fiId)
      .then((res: EocEmailEvent[]) => {
        this.eocEmailEvents = res;
        this.getSendHistoryForSelectedCycle();
      });
  }

  @Watch('selectedCycleDropDownItem')
  getSendHistoryForSelectedCycle() {
    this.sendHistoryForSelectedCycle = [];
    if (this.selectedCycleDropDownItem?.dropDate) {
      this.sendHistoryForSelectedCycle = this.eocEmailEvents
        .filter(event => this.getFormattedDropDate(event.cycleDropDate) === this.selectedCycleDropDownItem?.dropDate)
        .sort((event1, event2) => {
          if (event1.timestamp < event2.timestamp) {
            return 1;
          }
          return -1;
        });
    }
  }

  @Watch('selectedCycleDropDownItem')
  getEocEmailMetrics() {
    this.eocEmailMetricsForSelectedCycle = null;
    if (!this.selectedCycleDropDownItem || !this.selectedCycleDropDownItem?.id) {
      return;
    }
    this.isEmailCountLoading = true;
    this.eocEmailMetricsResource
      .get(this.fiId, this.selectedCycleDropDownItem?.id!)
      .then((res) => {
        this.eocEmailMetricsForSelectedCycle = res;
      })
      .finally(() => {
        this.isEmailCountLoading = false;
      });
  }

  onHomeUrlChange() {
    const existingUrl: string = (this.eocEmailConfig && this.eocEmailConfig.fiHomePageUrl) ? this.eocEmailConfig.fiHomePageUrl : '';
    const workingUrl: string = this.workingEocEmailConfig.fiHomePageUrl;
    const existingManualOverride: boolean = (this.eocEmailConfig && this.eocEmailConfig.fiHomePageUrlManualVerified) ? this.eocEmailConfig.fiHomePageUrlManualVerified : false;
    this.workingEocEmailConfig.fiHomePageUrlManualVerified = workingUrl === existingUrl
        && existingUrl !== '' && existingManualOverride === true;
  }

  getLatestProductSendTimestamp(product: Product) {
    if (this.selectedCycleDropDownItem?.dropDate) {
      const matches = this.eocEmailEvents
        .filter(event => event.externalProductMappingId === product.productMapping.externalProductMappingId
            && this.getFormattedDropDate(event.cycleDropDate)
                === this.selectedCycleDropDownItem?.dropDate)
        .sort((event1, event2) => {
          if (event1.timestamp < event2.timestamp) {
            return 1;
          }
          return -1;
        });
      if (matches.length === 0) {
        return 'Never Sent For Cycle';
      }
      return this.formatTimestamp(matches[0].timestamp);
    }
    return 'No Cycle Selected';
  }

  formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', { timeZone: 'America/Chicago' });
  }

  getEocEmailCount(product: Product) {
    if (this.eocEmailMetricsForSelectedCycle
        && this.eocEmailMetricsForSelectedCycle.externalProductMappingIdEmailCounts
        && (String(product.productMapping.externalProductMappingId)
          in this.eocEmailMetricsForSelectedCycle.externalProductMappingIdEmailCounts)) {
      return this.eocEmailMetricsForSelectedCycle.externalProductMappingIdEmailCounts[product.productMapping.externalProductMappingId!];
    }
    return 'N/A';
  }

  sendTestEmail() {
    if (!this.emailPattern.test(this.testEmailAddress as string)) {
      this.setError('Enter a valid Test Email Address!');
      return;
    }

    this.enableSendEmail = false;
    const testEmail: TestEmail = {
      testEmailAddress: this.testEmailAddress as string,
    };
    this.sendEocEmailResource.testEocEmail(this.fiId, this.selectedCycleDropDownItem?.id as number, testEmail)
      .then(() => {
        this.showSuccess('Sent test EOC email');
      })
      .catch((error) => {
        this.showError(error);
      });
  }

  sendEmailNow() {
    const dialog = new Dialog('Confirm',
      'Are you sure you want to send EOC emails to ALL accounts?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          this.enableSendEmail = false;
          this.sendEocEmailResource.sendEocEmail(this.fiId, this.selectedCycleDropDownItem?.id as number)
            .then(() => {
              this.loadAllData();
              this.showSuccess('Sent EOC email');
            })
            .catch((error) => {
              this.showError(error);
            });
        }
      });
  }

  onEocEmailEnableFlagModified() {
    this.hasUnsavedEnableEocEmailFlag = false;
    this.activeProducts.forEach((product) => {
      if (product.eocEmailEnabled !== this.eocEmailEnableFlagsOnLoad.get(product.id!)) {
        this.hasUnsavedEnableEocEmailFlag = true;
      }
    });
  }

  // this is temporary while we still are supporting ehlEnabled flag
  onHousingLogoChange() {
    this.workingEocEmailConfig.ehlEnabled = this.workingEocEmailConfig.housingLogo === 'EHL';
  }

  @Watch('workingEocEmailConfig', { deep: true })
  isConfigDataModified() {
    if (JSON.stringify(this.eocEmailConfig) !== JSON.stringify(this.workingEocEmailConfig)) {
      this.hasUnsavedConfigData = true;
    } else {
      this.hasUnsavedConfigData = false;
    }
  }

  @Watch('workingEocEmailConfig.emailProvider')
  onEmailProviderChange() {
    this.adjustBatchSizeOnEmailProviderChange();
    this.adjustFromSfmcEmailDomainOnEmailProviderChange();
  }

  @Watch('workingEocEmailConfig.batchSize')
  onBatchSizeChange() {
    this.hasInvalidBatchSize = !this.isBatchSizeValid();
  }

  validateConfigData() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      return true;
    }
    return false;
  }

  saveEocEmailSettings() {
    if (!this.validateConfigData()) {
      this.setError('Please correct errors in the form!');
      return;
    }
    if (!this.emailPattern.test(this.workingEocEmailConfig.fiContactEmail)) {
      const dialog = new Dialog('Confirm', 'Contact Email is not a valid email, are you sure you want to save?');
      dialog.setAcceptLabel('OK').setDeclineLabel('Cancel');
      this.$store.dispatch('notices/add', dialog)
        .then((ok) => {
          if (ok === 'accept') {
            this.saving = true;
            this.adjustBatchSizeBeforeSave();
            Promise.allSettled([this.saveActiveProducts(), this.saveEocEmailConfig()])
              .then((results) => {
                this.saving = false;
              });
          }
        });
    } else {
      this.saving = true;
      Promise.allSettled([this.saveActiveProducts(), this.saveEocEmailConfig()])
        .then((results) => {
          this.saving = false;
        });
    }
  }

  saveEocEmailConfig() {
    return new Promise<void>((resolve, reject) => {
      if (this.hasUnsavedConfigData) {
        this.eocEmailConfigResource.update(this.fiId, this.workingEocEmailConfig)
          .then((res: EocEmailConfig) => {
            this.eocEmailConfig = res;
            this.initializeWorkingEocEmailConfig();
            this.invalidUrlError = false;
            resolve();
          })
          .catch((error) => {
            if (this.isInvalidURLError(error)) {
              this.invalidUrlError = true;
              this.workingEocEmailConfig.fiHomePageUrlManualVerified = false;
              this.setError(`Error, did not save configurations.  Invalid or unreachable homepage URL: ${this.workingEocEmailConfig.fiHomePageUrl}`);
            } else {
              this.showError(error);
            }
            reject();
          });
      } else {
        this.invalidUrlError = false;
        resolve();
      }
    });
  }

  saveActiveProducts() {
    const promises: Promise<void>[] = [];
    this.activeProducts.forEach((product) => {
      if (product.eocEmailEnabled !== this.eocEmailEnableFlagsOnLoad.get(product.id!)) {
        promises.push(new Promise<void>((resolve, reject) => {
          this.productResource.update(this.fiId, product)
            .then((returnedProduct) => {
              this.showSuccess(`Saved product: ${returnedProduct.id}`);
              resolve();
            })
            .catch((error) => {
              this.showError(error);
              reject();
            });
        }));
      }
    });

    return Promise.allSettled(promises).then(() => {
      this.getEocEmailEnableFlagsOnLoad();
    });
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else if (error.response && typeof error.response.data === 'string') {
      this.setError(error.response.data);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccess(message: string) {
    const al = new Alert(message, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  isInvalidURLError = (error: any) : boolean => {
    if (typeof error.response.data !== 'string') {
      return false;
    }

    const asString : string = error.response.data;
    return asString.includes('ERR_INV_OR_UNREACHABLE_HOME_URL');
  }

  adjustBatchSizeBeforeSave() {
    if (this.workingEocEmailConfig.emailProvider === 'SPARKPOST') {
      this.workingEocEmailConfig.batchSize = 50;
    }
  }

  adjustBatchSizeOnEmailProviderChange() {
    if (this.saving || this.loading) {
      return;
    }

    if (this.workingEocEmailConfig.emailProvider === 'SALESFORCE_MARKETING_CLOUD') {
      this.workingEocEmailConfig.batchSize = 10;
    } else if (this.workingEocEmailConfig.emailProvider === 'SPARKPOST') {
      this.workingEocEmailConfig.batchSize = 50;
    }
  }

  adjustFromSfmcEmailDomainOnEmailProviderChange() {
    if (this.saving || this.loading) {
      return;
    }

    if (this.workingEocEmailConfig.emailProvider === 'SALESFORCE_MARKETING_CLOUD') {
      this.workingEocEmailConfig.fromSfmcEmailDomain = '@email.rewardlocally.com';
    }
  }

  isBatchSizeValid() : boolean {
    if (this.workingEocEmailConfig.emailProvider === 'SALESFORCE_MARKETING_CLOUD') {
      const validation = ValidationTool.requiredAndBetweenRuleFunction(this.workingEocEmailConfig.batchSize, 1, 100, '');
      const isValid = validation === true;
      return isValid === true;
    } if (this.workingEocEmailConfig.emailProvider === 'SPARKPOST') {
      const batchSize = this.workingEocEmailConfig.batchSize;
      return `${batchSize}` === '50';
    }
    return false;
  }
}


interface CycleDropDownItem {
    dropDate: string,
    id: number,
}
